/**
 * Paul Kenzie: tüm sayfalarda çalışan küçük davranışlar.
 * - ≥990 px'te açık çekmecenin (filtre, sepet) arkasındaki karartmaya tıklanınca çekmece kapanır.
 *   Karartma pk-theme.css'te body::after; tıklamanın hedefi body olur.
 */
document.addEventListener('click', (event) => {
  if (event.target !== document.body) return;
  if (!document.querySelector('.page-wrapper--drawer-open')) return;
  const drawer = /** @type {HTMLElement & { close?: () => void } | null} */ (document.querySelector('theme-drawer[open]'));
  if (drawer) drawer.close?.();
  else document.querySelector('.page-wrapper--drawer-open')?.classList.remove('page-wrapper--drawer-open');
});

/**
 * Candy Rack "Slider Cart" (KAN-95): sepet ikonu ve sepete ekleme hem uygulamanın sepetini hem temanın sepet
 * çekmecesini açıyor; görünen uygulamanınki. Temanın çekmecesi kapatılır. Kapatma, açılış olayının diğer dinleyicileri
 * bittikten sonra yapılır: aynı anda kapatınca Horizon'un karartma sınıfı (.page-wrapper--drawer-open) çekmece kapalıyken
 * geri ekleniyor, sayfa karartılı ve kilitli kalıyordu. Açık çekmece yokken kalan karartma da temizlenir.
 */
const CANDY_CART_ID = 'candyrack-slider-cart-wrapper';
const isCandyCartOpen = () => /cartStylesShow/.test(document.getElementById(CANDY_CART_ID)?.className ?? '');
/** Uygulamanın sepetinin en son açıldığı an (geri dönüşte "hiç açılmadı mı" kontrolü için). */
let candyOpenedAt = 0;

const clearStaleOverlay = () => {
  if (document.querySelector('theme-drawer[open]')) return;
  document.querySelector('.page-wrapper--drawer-open')?.classList.remove('page-wrapper--drawer-open');
};

const closeThemeCart = () => {
  const drawer = /** @type {HTMLElement & { close?: () => Promise<void> } | null} */ (document.getElementById('cart-drawer'));
  if (drawer?.hasAttribute('open')) drawer.close?.();
  setTimeout(clearStaleOverlay, 0);
};

/** Uygulamanın sepeti mağazada açık mı (kendi kök öğesi ve openCart işlevi). */
const candyCartEnabled = () =>
  !!document.getElementById(CANDY_CART_ID) &&
  typeof (/** @type {any} */ (window).CandyRackSliderCart?.openCart) === 'function';

// Uygulamanın sepeti açıkken temanın sepeti hiç gösterilmez (önce temanınki, sonra uygulamanınki açılıyordu).
// Uygulama sepete eklemeden 2–3 sn sonra açılıyor; açılmazsa geri bildirim kalmasın diye uygulamanınki açtırılır.
document.addEventListener('theme-drawer:open', (event) => {
  if (!(event.target instanceof HTMLElement) || event.target.id !== 'cart-drawer' || !candyCartEnabled()) return;
  const suppressedAt = Date.now();
  setTimeout(() => {
    closeThemeCart();
    if (isCandyCartOpen()) return;
    // Yalnızca o arada hiç açılmadıysa; müşteri açılıp kapattıysa yeniden açılmaz.
    setTimeout(() => {
      if (candyOpenedAt < suppressedAt && !isCandyCartOpen()) /** @type {any} */ (window).CandyRackSliderCart?.openCart?.();
    }, 2500);
  }, 0);
});

/** Uygulamanın kök öğesi sabit; içindeki sepet öğesi yeniden oluşturulsa da açılıp kapanması buradan izlenir. */
const watchCandyRoot = (/** @type {HTMLElement} */ root) => {
  let wasOpen = isCandyCartOpen();
  new MutationObserver(() => {
    const open = isCandyCartOpen();
    if (open === wasOpen) return;
    wasOpen = open;
    if (open) candyOpenedAt = Date.now();
    setTimeout(open ? closeThemeCart : clearStaleOverlay, 0);
  }).observe(root, { subtree: true, attributes: true, attributeFilter: ['class'] });
};

const candyRoot = document.getElementById('candyrack-slider-cart-root');
if (candyRoot) {
  watchCandyRoot(candyRoot);
} else {
  // Uygulama kökü sayfa yüklendikten sonra ekliyor; bulununca izlemeye geçilir.
  const finder = new MutationObserver(() => {
    const root = document.getElementById('candyrack-slider-cart-root');
    if (!root) return;
    finder.disconnect();
    watchCandyRoot(root);
  });
  finder.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => finder.disconnect(), 20000);
}

/**
 * PK-08 / KAN-32: yukarı kaydır butonu. Sayfanın en üstündeki işaretçi görünmez olunca buton belirir.
 * ≥990 px'te Horizon'da kaydırılan kap .page-wrapper olabildiği için işaretçi onun ilk çocuğu yapılır ve
 * tıklamada hem pencere hem .page-wrapper başa kaydırılır.
 */
(() => {
  const strings = /** @type {{ scrollTop?: string }} */ (window.pkStrings || {});
  const scroller = document.querySelector('.page-wrapper');
  const sentinel = document.createElement('div');
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'display:block;flex:none;height:0;margin:0;';
  (scroller || document.body).prepend(sentinel);

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'pk-scroll-top';
  button.setAttribute('aria-label', strings.scrollTop || 'Yukarı kaydır');
  button.tabIndex = -1;
  // Font Awesome 5 Pro light "arrow-up" (canlı temayla aynı ikon).
  button.innerHTML =
    '<svg aria-hidden="true" viewBox="0 0 448 512" fill="currentColor"><path d="M4.465 263.536l7.07 7.071c4.686 4.686 12.284 4.686 16.971 0L207 92.113V468c0 6.627 5.373 12 12 12h10c6.627 0 12-5.373 12-12V92.113l178.494 178.493c4.686 4.686 12.284 4.686 16.971 0l7.07-7.071c4.686-4.686 4.686-12.284 0-16.97l-211.05-211.05c-4.686-4.686-12.284-4.686-16.971 0L4.465 246.566c-4.687 4.686-4.687 12.284 0 16.97z"/></svg>';
  document.body.append(button);

  new IntersectionObserver(([entry]) => {
    const visible = !entry?.isIntersecting;
    button.classList.toggle('is-visible', visible);
    button.tabIndex = visible ? 0 : -1;
  }).observe(sentinel);

  button.addEventListener('click', () => {
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    window.scrollTo({ top: 0, behavior });
    scroller?.scrollTo({ top: 0, behavior });
  });
})();

/**
 * PK-18 / PK-19: Paul Kenzie pencereleri (Bir soru sor, Paylaş).
 * [data-pk-open-dialog="id"] pencereyi açar, [data-pk-close-dialog] ya da karartmaya tıklamak kapatır.
 * Paylaş: dokunmatik cihazda tarayıcı destekliyorsa yerel paylaşım menüsü açılır, desteklemiyorsa pencere.
 * Bağlantı alanına odaklanınca bağlantı seçilir ve panoya kopyalanır.
 */
document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;

  const opener = target.closest('[data-pk-open-dialog]');
  if (opener instanceof HTMLElement) {
    const shareUrl = opener.dataset.pkShareUrl;
    if (shareUrl && navigator.share && window.matchMedia('(pointer: coarse)').matches) {
      navigator.share({ url: shareUrl, title: opener.dataset.pkShareTitle || document.title }).catch(() => {});
      return;
    }
    const dialog = document.getElementById(opener.dataset.pkOpenDialog || '');
    if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
    return;
  }

  if (target.closest('[data-pk-close-dialog]')) {
    target.closest('dialog')?.close();
    return;
  }

  // Karartmaya (pencerenin dışına) tıklama: hedef dialog'un kendisi olur.
  if (target instanceof HTMLDialogElement && target.classList.contains('pk-modal')) target.close();
});

document.addEventListener('focusin', (event) => {
  const input = event.target;
  if (input instanceof HTMLInputElement && input.hasAttribute('data-pk-copy')) {
    input.select();
    navigator.clipboard?.writeText(input.value).catch(() => {});
  }
});

// İletişim formu gönderildikten sonra sayfa sonuçla döner; sonucu göstermek için pencereyi yeniden aç.
document.querySelector('[data-pk-reopen]')?.closest('dialog')?.showModal();

/**
 * PK-31: arama penceresinin formu ("Tümünü görüntüle") canlıdaki gibi tükenen ürünleri sona koysun.
 * Horizon formunda yalnızca options[prefix] var; eksik seçenek burada eklenir (çekirdek dosyaya dokunmadan).
 */
for (const form of document.querySelectorAll('#search-modal form.predictive-search-form')) {
  if (form.querySelector('input[name="options[unavailable_products]"]')) continue;
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'options[unavailable_products]';
  input.value = 'last';
  form.append(input);
}

/**
 * PK-09 / KAN-33: kaydırınca belirme. html[data-pk-reveal] yoksa (ayar kapalı, hareket azaltma, editör) hiçbir şey yapmaz.
 * Hedefler pk-theme.css'teki listeyle aynı. Horizon ızgarayı yeniden çizdiğinde (filtre, sayfa) yeni kartlar da izlenir.
 */
if (document.documentElement.hasAttribute('data-pk-reveal')) {
  const REVEAL_TARGETS = 'product-card, .pk-reveal, .pk-product-tabs, .blog-post-card, .resource-card';
  const revealObserver = new IntersectionObserver(
    (entries, observer) => {
      let order = 0;
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        const target = /** @type {HTMLElement} */ (entry.target);
        if (target.matches('product-card')) target.style.setProperty('--pk-reveal-order', String(order++));
        target.classList.add('pk-reveal--in');
        observer.unobserve(target);
      }
    },
    { rootMargin: '0px 0px -50px 0px' }
  );
  const observeTargets = (root = document) => {
    for (const element of root.querySelectorAll(REVEAL_TARGETS)) {
      if (!element.classList.contains('pk-reveal--in')) revealObserver.observe(element);
    }
  };
  observeTargets();
  /** @type {Window & { pkRevealReady?: boolean }} */ (window).pkRevealReady = true;
  let revealQueued = false;
  new MutationObserver(() => {
    if (revealQueued) return;
    revealQueued = true;
    requestAnimationFrame(() => {
      revealQueued = false;
      observeTargets();
    });
  }).observe(document.body, { childList: true, subtree: true });
}

/**
 * PK-15 / KAN-42: son görüntülenen ürünler geçmişi. Ürün sayfasında (window.pkProductHandle, pk-head) handle
 * listenin başına eklenir; en fazla 12 tutulur. sections/pk-recently-viewed.liquid okur.
 */
{
  const handle = /** @type {Window & { pkProductHandle?: string }} */ (window).pkProductHandle;
  if (handle) {
    try {
      /** @type {string[]} */
      const history = JSON.parse(localStorage.getItem('pk-recently-viewed') || '[]');
      const next = [handle, ...history.filter((item) => item !== handle)].slice(0, 12);
      localStorage.setItem('pk-recently-viewed', JSON.stringify(next));
    } catch {
      // Depolama kapalıysa geçmiş tutulmaz.
    }
  }
}

/**
 * KAN-74: hediye kartında "Bunu hediye olarak göndermek istiyorum." kutusu (snippets/gift-card-recipient-form.liquid).
 * Horizon'ın gizli "E-posta adresim / Alıcının e-posta adresi" seçeneklerinden uygun olanı tıklar; alıcı alanlarını
 * Horizon'ın kendi kodu (gift-card-recipient-form.js) açıp kapatır.
 */
document.addEventListener('change', (event) => {
  const toggle = event.target;
  if (!(toggle instanceof HTMLInputElement) || !toggle.hasAttribute('data-pk-gift-toggle')) return;
  const form = toggle.closest('gift-card-recipient-form');
  const option = form?.querySelector(toggle.checked ? '[ref="recipientEmailButton"]' : '[ref="myEmailButton"]');
  if (option instanceof HTMLInputElement && !option.checked) option.click();
});

/**
 * KAN-98: "Beden Rehberi" penceresi (blocks/pk-size-guide.liquid). Yerel <dialog>; arka plana tıklayınca ve Esc ile kapanır.
 */
document.addEventListener('click', (event) => {
  const target = event.target instanceof Element ? event.target : null;
  if (!target) return;
  const opener = target.closest('[data-pk-size-guide-open]');
  if (opener) {
    const dialog = document.getElementById(opener.getAttribute('aria-controls') || '');
    if (dialog instanceof HTMLDialogElement && !dialog.open) dialog.showModal();
    return;
  }
  const dialog = target.closest('dialog.pk-size-guide__dialog');
  if (!(dialog instanceof HTMLDialogElement)) return;
  // Kapat butonu ya da pencerenin dışı (dialog'un kendisi, yani backdrop) tıklanınca kapanır.
  if (target.closest('[data-pk-size-guide-close]') || target === dialog) dialog.close();
});
